import { Component, OnInit, Input, HostListener } from '@angular/core';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { CommonUtilityService } from 'src/app/shared/utility-services/common-utility.service';
import { PRODUCT_GROUPS } from 'src/app/angular-elements/plan-selection/enums/product-groups.enum';
import { PlansStateStructure } from 'src/app/angular-elements/plan-selection/configs/interfaces/plansStateStructure.interface';
import { DomSanitizer } from '@angular/platform-browser';
import { DateService } from 'src/app/shared/services/date.service';
import { EnrollmentAppStateStructure } from '../../shared/interfaces/enrollmentAppStateStructure.interface';
// import * as _moment from 'moment';
import type { Moment } from 'moment';
import { INDIVIDUAL_MARKET_STATE_NAME } from '../../form-wrappers/plan-enrollment/individual-plan-enrollment-form/configs/reducers/individual-market.reducer';
import { IndividualMarketStateStructure } from '../../form-wrappers/plan-enrollment/individual-plan-enrollment-form/configs/interfaces/individualMarket.interfaceStateStructure';
import { EnrollmentStateStructure } from '../../shared/interfaces/enrollmentStateStructure.interface';
import { PharmacyState, PHARMACY_REDUX_STATE_ID } from '../../medical-information/pharmacy-information/configs/reducers/pharmacy.reducer';
// const moment = _moment;
import moment from 'moment';

@Component({
    selector: 'app-view-plan',
    templateUrl: './view-plan.component.html',
    styleUrls: ['./view-plan.component.scss'],
    standalone: false
})
export class ViewPlanComponent implements OnInit {

  @Input() printButtonExperienceType: "special-enrollment" | "enhanced-pdf-print" | null;

  planName: string;

  confirmationAppId: string;
  effectiveDate: string;
  submittedDate: string;
  showEffectiveDate: boolean = true;
  hasDrugInfo: boolean = false;

  @HostListener('window:beforeunload')
  onBeforeUnload() {
    this.commonUtilityService.resetStateExceptUserData();
  }

  constructor(
    private commonUtilityService: CommonUtilityService,
    private reducerUtilityService: ReducerUtilityService,
    public sanitizer: DomSanitizer,
    private dateUtility: DateService
  ) { }

  ngOnInit(): void {
    this.setDisplayData();
  }

  getEffectiveDate(effectiveDate) {
    if (effectiveDate.split) {
      return effectiveDate.split('-')[0];
    } else {
      return effectiveDate;
    }
  }

  setDisplayData() {
    const pharmacyState: PharmacyState = this.reducerUtilityService.getState(PHARMACY_REDUX_STATE_ID);
    const planState: PlansStateStructure = this.reducerUtilityService.getState('Plans');
    const eApp: EnrollmentAppStateStructure = this.reducerUtilityService.getState('EnrollmentApp');
    const indState: IndividualMarketStateStructure = this.reducerUtilityService.getPayloadState(INDIVIDUAL_MARKET_STATE_NAME);
    const enrollmentState: EnrollmentStateStructure = this.reducerUtilityService.getPayloadState('enrollment');
    let enrollmentData;

    // Set enrollment object based on product group/app data
    if (
      planState.activeProductGroup === PRODUCT_GROUPS.OFF_EXCHANGE ||
      planState.activeProductGroup === PRODUCT_GROUPS.DENTAL ||
      planState.activeProductGroup === PRODUCT_GROUPS.BLUE_EDGE_BALANCE
    ) {
      enrollmentData = indState.enrollment;
    }
    else {
      enrollmentData = enrollmentState;
    }

    // Get correct effective date
    if (enrollmentData.effectiveDate) {
      this.effectiveDate = this.getEffectiveDate(enrollmentData.effectiveDate);
    }
    else if (enrollmentData.coverageDate) {
      this.effectiveDate = this.dateUtility.getDateAsFormattedString(enrollmentData.coverageDate, 'MM/DD/YYYY');
    }

    // Determine if we have drug data
    if (pharmacyState?.pharmacys?.length) {
      this.hasDrugInfo = true;
    }

    // Set base app and plan details
    let tempDate = moment(eApp.submittedDate);
    if (tempDate.isValid()) {
      this.submittedDate = tempDate.format('MM/DD/YYYY');
    }

    this.confirmationAppId = eApp.appId;
    this.planName = enrollmentData?.productData?.planDetails?.productName;

    if (planState.activeProductGroup === PRODUCT_GROUPS.WHOLE_HEALTH_BALANCE) {
      this.planName = 'Whole Health Balance';
      this.showEffectiveDate = false;
    }
  }
}
